import * as yup from 'yup';
import { useForm, UseFormReturn } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { CreateExternalAppDto } from '../../../api-client';

export const useCreateExternalAppForm = (): UseFormReturn<CreateExternalAppDto> => {
  const schema = yup.object().shape(
    {
      name: yup
        .string()
        .required('Name can not be empty')
        .min(3, 'Name must be at least 3 characters long')
        .max(256, 'Name can not be longer than 256 characters'),
      description: yup
        .string()
        .nullable()
        .notRequired()
        .when('description', {
          is: (val: string | null | undefined) => val?.length,
          then: (rule) =>
            rule
              .min(5, 'Description must be at least 5 characters long')
              .max(256, 'Name can not be longer than 256 characters'),
        }),
      apiKey: yup
        .string()
        .notRequired()
        .when('apiKey', {
          is: (val: string | null | undefined) => val?.length,
          then: (rule) =>
            rule
              .min(40, 'API Key must be at least 40 characters long')
              .max(60, 'API Key can not be longer than 60 characters'),
        }),
    },
    [
      ['description', 'description'],
      ['apiKey', 'apiKey'],
    ],
  );

  return useForm<CreateExternalAppDto>({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });
};
